const NOTES_KEY = 'calendar_notes';

export const saveNotes = (notes) => {
  localStorage.setItem(NOTES_KEY, JSON.stringify(notes));
};

export const loadNotes = () => {
  const saved = localStorage.getItem(NOTES_KEY);
  return saved ? JSON.parse(saved) : {};
};